'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _reactAvatar = require('react-avatar');

var _reactAvatar2 = _interopRequireDefault(_reactAvatar);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonDestroy = function ButtonDestroy(_ref) {
  var onClick = _ref.onClick;
  return _react2.default.createElement('button', {
    type: 'button',
    className: 'pull-right close-notification-button icon-cg-close',
    onClick: onClick
  });
};

var ActivityRequest = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ActivityRequest, _Component);

  function ActivityRequest() {
    (0, _classCallCheck3.default)(this, ActivityRequest);
    return (0, _possibleConstructorReturn3.default)(this, (ActivityRequest.__proto__ || (0, _getPrototypeOf2.default)(ActivityRequest)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActivityRequest, [{
    key: 'togglePopover',
    value: function togglePopover() {
      this.refs.overlay.toggle();
    }
  }, {
    key: 'handleDestroyNotification',
    value: function handleDestroyNotification() {
      var _props = this.props,
          notification = _props.notification,
          isArchivedPage = _props.isArchivedPage,
          handleArchive = _props.handleArchive,
          handleDestroy = _props.handleDestroy;


      this.refs.overlay.toggle();

      if (isArchivedPage) {
        handleDestroy(notification.id);
      } else {
        handleArchive(notification.id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          notification = _props2.notification,
          isArchivedPage = _props2.isArchivedPage,
          polyglot = _props2.polyglot,
          handleDecline = _props2.handleDecline,
          handlePublish = _props2.handlePublish,
          showEventModal = _props2.showEventModal;

      var createdAt = (0, _moment2.default)(notification.created_at.date).fromNow(); // eslint-disable-line camelcase
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.OverlayTrigger,
          {
            ref: 'overlay',
            trigger: 'click',
            rootClose: true,
            placement: 'bottom',
            overlay: _react2.default.createElement(
              _reactBootstrap.Popover,
              { id: 'activityRequestPopover', animation: false, className: 'notification-item-popover', lol: 'props' },
              _react2.default.createElement(
                'b',
                null,
                polyglot.t('notification.activity.request.action.title')
              ),
              _react2.default.createElement(
                'p',
                null,
                polyglot.t('notification.activity.request.action.message')
              ),
              _react2.default.createElement(
                'div',
                { className: 'popover-actions' },
                _react2.default.createElement(
                  'div',
                  { className: 'buttons' },
                  _react2.default.createElement(
                    'button',
                    {
                      className: 'btn btn-default btn-outline',
                      onClick: this.togglePopover.bind(this)
                    },
                    polyglot.t('button.cancel')
                  ),
                  '\xA0',
                  _react2.default.createElement(
                    'button',
                    {
                      className: 'btn btn-primary',
                      onClick: this.handleDestroyNotification.bind(this)
                    },
                    isArchivedPage ? polyglot.t('button.destroy') : polyglot.t('button.archive')
                  )
                )
              )
            )
          },
          _react2.default.createElement(ButtonDestroy, null)
        ),
        _react2.default.createElement(_reactAvatar2.default, {
          size: 26,
          src: notification.source.item && notification.source.item.avatar && notification.source.item.avatar.thumbnail ? notification.source.item.avatar.thumbnail : '',
          email: notification.source.item.email,
          name: notification.source.item.name
        }),
        '\xA0',
        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: polyglot.t('notification.activity.request.message', { sourceName: notification.source.item.name, destinationName: notification.destination.item.name }) } }),
        '\xA0',
        _react2.default.createElement(
          'small',
          null,
          createdAt
        ),
        _react2.default.createElement(
          'div',
          { className: 'notification-item-detail' },
          _react2.default.createElement(_components.NotificationEvent, {
            notification: notification,
            handleDecline: handleDecline,
            handlePublish: handlePublish,
            polyglot: polyglot,
            showEventModal: showEventModal
          })
        )
      );
    }
  }]);
  return ActivityRequest;
}(_react.Component), _class.propTypes = {
  notification: _propTypes2.default.object,
  isArchivedPage: _propTypes2.default.bool,
  handleArchive: _propTypes2.default.func,
  handleDecline: _propTypes2.default.func,
  handleDestroy: _propTypes2.default.func,
  handlePublish: _propTypes2.default.func,
  openModal: _propTypes2.default.func,
  showEventModal: _propTypes2.default.func,
  source: _propTypes2.default.object,
  polyglot: _propTypes2.default.object,
  publish: _propTypes2.default.func
}, _temp);
exports.default = ActivityRequest;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/Activity/ActivityRequest.js
// module id = 2234
// module chunks = 0